import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../common.service';
import { Profile, PaymentMethod } from 'profile-api';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-prepaid-packets',
  templateUrl: './prepaid-packets.component.html',
  styleUrls: ['./prepaid-packets.component.css']
})
export class PrepaidPacketsComponent implements OnInit {
//   @Input('fromTender') fromTender: boolean;
//   @Input('fromQuoteBuy') fromQuoteBuy: boolean;

  profile: Profile = {};
  creditExpired: boolean = false;
  participationCreditExpired: boolean = false;

  constructor(
    private commonService: CommonService,
    private router: Router
  ) { }

  ngOnInit(): void {
    window['moment'] = moment;
    this.commonService.getProfile().then((profile: Profile) => {
      this.profile = profile;
      this.creditExpired = moment(profile.prepaidCredits.expirationDate) <  moment();
      this.participationCreditExpired = moment(profile.participationPrepaidCredits.expirationDate) <  moment();
    });
  }

  buyPrepaidPacket(isTenderPacket: boolean) {
    this.commonService.saveProfile(this.profile).then(
      (pro:Profile) => {        
        this.commonService.getPaymentMethodService().profilePaymentMethodGet().subscribe(
          (paymentMethod: PaymentMethod) => {
            //   if (this.fromTender) {
            //       this.router.navigate(['/acquistapacchetto'], { queryParams: { "fromTender":  'yes', "isTender":  'yes'}});
            //   } else if (this.fromQuoteBuy){
            //       this.router.navigate(['/acquistapacchetto'], { queryParams: { "fromQuoteBuy":  'yes', "isTender":  'yes'}});
            //   } else {
            this.router.navigate(['/acquistapacchetto'], { queryParams: { "isTenderPacket":  isTenderPacket}});
              //}
          },
          (error) => {
            this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'paymentMethod', "fromPrepaidPacketBuy": 'yes', "isTenderPacket":  isTenderPacket} });
          }
        )
      }
    ).catch(
      (error) => {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'profile', "fromPrepaidPacketBuy": 'yes', "isTenderPacket":  isTenderPacket} });
      }
    );
  }

  buyTenderPrepaidPacket() {
      this.buyPrepaidPacket(true);
  }

  buyParticipationPrepaidPacket() {
    this.buyPrepaidPacket(false);
  }

  goToProfile() {
    this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'profile' } });
  }

}


